export default __webpack_public_path__ + "static/media/hoppia_events_purple.2e6269eb.svg";